import { render, staticRenderFns } from "./level.vue?vue&type=template&id=1a555043&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"
import style0 from "./level.vue?vue&type=style&index=0&id=1a555043&prod&scoped=true&lang=css"
import style1 from "./level.vue?vue&type=style&index=1&id=1a555043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a555043",
  null
  
)

export default component.exports